import React from 'react';
export default function VerticalLinearStepper() {
    return(
        <div>
            <section id="cd-timeline" class="cd-container">

                <div class="cd-timeline-block">
                    <div class="cd-timeline-img cd-picture">
                    </div>
                    <div class="cd-timeline-content">
                        <h2>CHP & ORC</h2>
                        <p>Electricity production and storage will be integrated to the hybrid module by using combined heat and power 
                        (CHP) and organic Rankine cycle (ORC) technologies. 
                        During the project, the most cost-effective technical integration position and implementation
                        method for ORC technology, in the existing combustion process is chosen</p>

                    </div> 
                </div> 

                <div class="cd-timeline-block">
                    <div class="cd-timeline-img cd-movie">
                    </div>
                    <div class="cd-timeline-content">
                        <h2>Combustion Process Optimisation</h2>
                        <p>The optimization of the combustion process is carried out using mathematical models that are verified by
                        practical experimentation. The optimization parameters are the combustion
                        temperature, the mass and relative humidity of the raw material to be burnt, and the emissions of the combustion
                        process. </p>
                        <span class="cd-date"></span>
                    </div> 
                </div>

                <div class="cd-timeline-block">
                    <div class="cd-timeline-img cd-picture">
                    </div>

                    <div class="cd-timeline-content">
                        <h2>Electricity Storage</h2>
                        <p>During the project, the storage methods to be studied are selected and their validity is verified over a
                        time period of one year. The aim is to find out the best practices for storing electrical energy and to make
                        recommendations for storage times and energy storage capacities</p>
                        <span class="cd-date"></span>
                    </div> 
                </div>

                <div class="cd-timeline-block">
                    <div class="cd-timeline-img cd-location">
                    </div>

                    <div class="cd-timeline-content">
                        <h2>Publications & Workshops</h2>
                        <p>The results of the project will be published in
                        national and international publication series, locally in workshops and seminars to be arranged in Pirkanmaa region.
                        The workshops involve companies to think, develop and make use of the project results in their own business. 
                        </p>
                        <span class="cd-date"></span>
                    </div>
                </div> 

	        </section> 
        </div>
    )
}